import React, { Fragment } from "react";
import { Row, Col } from "react-bootstrap";
import "../css/skills.css";
import dev from "../img/Programming-bro.svg";
import { skillData } from "../utils/skillData";

const Skills = () => {
  return (
    <Fragment>
      <div className="skills">
        <p className="side-text-skills">Skills</p>
        <h2 className="section-heading">Technical Skills</h2>
        <h2 className="section-quote">
          "What really matters, is the depth of your heart and the strength of
          your character"
        </h2>
        <hr />

        <Row className="full-page">
          <Col lg={5} md={5} sm={1} xs={1} className="skill-img-col">
            <img src={dev} className="dev-image" alt="dev-img" />
          </Col>
          <Col lg={7} md={7} xs={11}>
            <Row>
              {skillData.map((x) => {
                return (
                  <Col lg={2} md={2} sm={3} xs={3}>
                    <i className={`${x.className} ` + "devicon"}></i>
                    <p className="tech-label">{x.label}</p>
                  </Col>
                );
              })}
            </Row>
          </Col>

          <a name="workex"></a>
        </Row>
      </div>
    </Fragment>
  );
};

export default Skills;
